import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useForm, Controller } from 'react-hook-form';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';

import { StyledModal } from '@components/modal/ModalStyle';
import Checkbox from '@components/form/Toggle';
import Input from '@components/form/Input';

import { PROJECT_MODE } from '@utils/constants';
import { startPostProcessing } from '@utils/api';

const OdmPostprocessModal = ({ project_uuid, show, setShow }) => {
	const { ORTHOPHOTO } = PROJECT_MODE;

	const { control, handleSubmit } = useForm({
		defaultValues: {
			fileCount: '',
			fastOrtophoto: false,
		},
	});

	const [error, setError] = useState();
	const [success, setSuccess] = useState(false);

	const { mutate: start, loading } = useMutation({
		mutationFn: startPostProcessing,
		onError: err => {
			console.error('Error starting odm postprocessing from admin panel', err);
			setError(err?.response?.data?.detail ?? 'Unknown error');
			setSuccess(false);
		},
		onSuccess: () => {
			setError(null);
			setSuccess(true);
		},
	});

	const onSubmit = data => {
		setError(null);
		setSuccess(false);

		start({
			...data,
			projectUuid: project_uuid,
			projectMode: ORTHOPHOTO,
			isTif: false,
		});
	};

	return (
		<StyledModal
			variant="dark"
			show={show}
			centered={true}
			onHide={() => {
				setShow(false);
			}}>
			<Modal.Header closeButton closeVariant="white">
				<Modal.Title>ODM Postprocess</Modal.Title>
			</Modal.Header>

			<Form onSubmit={handleSubmit(onSubmit)}>
				<Modal.Body>
					{loading && (
						<div className="d-flex p-2 justify-content-center">
							<Spinner animation="border" variant="white" />
						</div>
					)}

					{success && <p className="alert alert-success">Process started successfully</p>}

					{error && <p className="alert alert-danger">Error: {error}</p>}

					{!loading && !success && (
						<>
							<Controller
								name="fileCount"
								control={control}
								render={({ field }) => (
									<Input {...field} type="number" label="Image count" required />
								)}
							/>

							<Controller
								name="fastOrtophoto"
								control={control}
								render={({ field }) => (
									<Checkbox
										{...field}
										label="Fast Orthophoto"
										checked={field.value}
									/>
								)}
							/>
						</>
					)}
				</Modal.Body>

				<Modal.Footer>
					<Button variant="secondary" onClick={() => setShow(false)}>
						Close
					</Button>
					<Button variant="success" type="submit" disabled={loading || success}>
						Run
					</Button>
				</Modal.Footer>
			</Form>
		</StyledModal>
	);
};
export default OdmPostprocessModal;
